import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setUser, selectIsAuthenticated } from "../../store/features/userSlice";
import { useNavigate } from "react-router";
import { Button } from "../../components/ui/button";
import { getAuth } from "../../lib/utils";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isAuthenticated = useSelector(selectIsAuthenticated);

  useEffect(() => {
    // Check localStorage on component mount
    const storedAuth = getAuth();
    if (storedAuth) {
      if (storedAuth.token) {
        dispatch(setUser(storedAuth));
        navigate("/monitoring-dashboard/resources");
      }
    }
  }, [dispatch, navigate]);

  // Also check Redux state for authentication
  useEffect(() => {
    if (isAuthenticated) {
      navigate("/monitoring-dashboard/resources");
    }
  }, [isAuthenticated, navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setMessage("");
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/v1.0/external/get-auth-token`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ email, password }),
        }
      );

      const data = await response.json();
      if (response.ok) {
        // Store both token and user data
        dispatch(
          setUser({
            token: data.accessToken,
            user: data.user,
          })
        );
        navigate("/compute-capacity");
      } else {
        setMessage(data.error || "Login failed");
      }
    } catch (error) {
      console.log(error);
      setMessage("Error: Something went wrong");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="w-full max-w-md space-y-8 p-8 rounded-lg">
        <div>
          <div className="flex items-center justify-center space-x-8">
            <img
              src="/images/cms-logo-horiz.png"
              className="h-12 w-auto"
              alt="CMS Logo"
            />
            <img
              src="/images/indiaai-logo.png"
              className="h-12 w-auto"
              alt="IndiaAI Logo"
            />
          </div>
          <h2 className="mt-6 text-center text-2xl font-bold tracking-tight text-gray-900">
            CMS IndiaAI Login
          </h2>
        </div>

        {message && (
          <div
            className="bg-destructive/10 border border-destructive text-destructive px-4 py-3 rounded-md relative"
            role="alert"
          >
            <span className="block sm:inline">{message}</span>
          </div>
        )}

        <form className="mt-8 space-y-6" onSubmit={handleLogin}>
          <div className="space-y-4 rounded-md">
            <div>
              <label
                htmlFor="email"
                className="block text-sm font-medium text-foreground"
              >
                Email address
              </label>
              <input
                id="email"
                name="email"
                type="email"
                required
                className="mt-1 block w-full px-3 py-2 bg-background border border-input rounded-md text-sm shadow-sm placeholder-muted-foreground focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div>
              <label
                htmlFor="password"
                className="block text-sm font-medium text-foreground"
              >
                Password
              </label>
              <input
                id="password"
                name="password"
                type="password"
                required
                className="mt-1 block w-full px-3 py-2 bg-background border border-input rounded-md text-sm shadow-sm placeholder-muted-foreground focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary"
                placeholder="Enter your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
          </div>

          <Button type="submit" className="w-full">
            Sign in
          </Button>
        </form>
      </div>
    </div>
  );
};

export default Login;
